<template>
  <v-col cols="12" lg="3">
    <v-card>
      <v-card-text class="text-center">
        <v-row>
          <v-col cols="12">
            <h4
              class="mt-2 title blue-grey--text text--darken-2 font-weight-regular"
            >
              {{ value }}
              <h6 class="subtitle-2 font-weight-light">
                {{  label }}
              </h6>
            </h4>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-col>
</template>


<script>
export default {
  props: ["value", "label"]
}
</script>
